export default __webpack_public_path__ + "static/media/git.09e6533b.svg";